import type { ReactNode } from 'react';
import React, { Children } from 'react';
import { ICONS } from 'Components/utils/icon/icons';
import { Icon } from 'Components/frameworks/icon/Icon';
type Props = {
  children: ReactNode;
  id?: string;
  onClear?: (arg0: React.SyntheticEvent) => void;
};
export const CriteriaControl = ({ children, onClear, id }: Props) => {
  if (!Children.count(children)) {
    return null;
  }

  return (
    <div className="mb-10 me-10 inline-block">
      <div className="outline-custom flex h-42 items-center gap-10 rounded-pill border-2 border-orange bg-white px-10 font-bold capitalize">
        {children}
        <button className="leading-0 text-inherit" data-testid={id} onClick={onClear} type="button">
          <Icon className="text-black" name={ICONS.CROSS} width="0.625rem" />
        </button>
      </div>
    </div>
  );
};
